import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AOS from 'aos';
import 'aos/dist/aos.css';

import './subscribe.css';


import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { SubForm } from '../components/SubForm';

const Subscribe = () => {

    useEffect(() => {
        AOS.init({
            duration: 2000,
            once: true,
            easing: "ease-out-cubic"
        });
    }, []);

    return (
        <div className="subscribe-container">
            <Helmet>
                <title>Iscrizione</title>
                <meta property="og:Iscrizione" content="Pagina iscrizione evento" />
            </Helmet>

            <Navbar />
            <div className="subscribe-heading">
                <h1 className="subscribeTitle Section-Heading">ISCRIVITI ALL&apos;EVENTO</h1>
                <p className="subscribe-text">
                    Compila il modulo qui sotto con tutti i dati richiesti per completare
                    la pre-iscrizione all&apos;evento.
                </p>
            </div>

            <div className="subscribe-wrap">

                <div className="tri tri-right" />
                <div className="tri tri-left" />

                <div className="subscribe-content" data-aos="fade-up" data-aos-duration="1500">
                    <SubForm />
                </div>

            </div>

            <Footer />
        </div>
    );
};

export default Subscribe;